import * as PROD_ENVIRONMENT from './environment.prod';
import { external } from './environment.shared';

export const environment = {
  ...PROD_ENVIRONMENT.environment,
  ...external,
  gatekeeperUrl: 'https://gatekeeper-rs-webservice.essp.c1.vanguard.com/gat/toggles/BT5'
};
